export enum FilterTypeDateEnum {
    CREATED_DATE = 'Cadastro',
    DEAD_LINE = 'Vencimento',
}

export type FilterTypeDate = 'CREATED_DATE' | 'DEAD_LINE';
